const validateBSDDevice = (formState) => {
  let form = {};
  if (!formState.deviceId) {
    form._error = "Device ID is required";
    form.invalid = true;
    return form;
  }
  
  if (formState.deviceType === 'LED') {
    if (!formState.category || !formState.displayColumnCount) {
      form._error = "Category and Display Column are required for LED displays";
      form.invalid = true;
      return form;
    }
  }
  
  form.invalid = false;
  return form;
};

export default validateBSDDevice;